<div class="dct-task-tree-selection-control w-100">
  <p-treeSelect
    class="w-full"
    containerStyleClass="dct-task-tree-selection"
    [(ngModel)]="selectedMilestoneId"
    [options]="nodes"
    display="chip"
    [metaKeySelection]="false"
    selectionMode="single"
    [placeholder]="'shared.searchTreePlaceholder' | translate"
    [loading]="loading"
    (onNodeExpand)="onNodeExpand($event)"
    (onNodeSelect)="onNodeSelect($event)">
  </p-treeSelect>

  <div *ngIf="selectionResult.milestone" class="selected-item">
    <b> {{ selectionResult.section.name }}</b> <em>/</em>
    <b> {{ selectionResult.project.name }}</b> <em>/</em>
    <b> {{ selectionResult.milestone.name }}</b>
  </div>
</div>
